import React, {FC, memo} from "react";
import Button from "../Button/Button";
import {BuilderSummaryProps} from "./BuilderSummary-types";
import {Action, Body, Price, Root} from "./BuilderSummary-styles";
import {usePrice} from "./BuilderSummary-hooks";
import {formatPrice} from "utils/FormatUtils";
import {useRecoilValue} from "recoil";
import {stateLoadingSubmit} from "data/atoms";
import {useConstructorSubmitText} from "hooks/useConstructorSubmitText";

const BuilderSummary: FC<BuilderSummaryProps> = memo((props) => {
    const {onSubmit} = props;

    const isLoading = useRecoilValue(stateLoadingSubmit);
    const buttonText = useConstructorSubmitText();

    const price = usePrice();

    return (
        <Root>
            <Body>
                <Price>
                    {formatPrice(price)} РУБ
                </Price>

                <Action>
                    <Button text={buttonText} onClick={onSubmit} isLoading={isLoading}/>
                </Action>
            </Body>
        </Root>
    )
});

export default BuilderSummary;
